export const ColorDrummondltd = {
    RedDrummond: '#E31937',
    YellowDrummond: '#FFF200',
    BlueDrummond: '#0072BC',
    GreenDrummond: '#8DC63F',
    OrangeDrummond: '#F26522',
    GrayDrummond: '#7C7C7B',
    YellowSeDrummond: '#FFC20E',
    BlueSeDrummond: '#4978BC',
}